import React from 'react';
import {SnackbarProps} from '@mui/material/Snackbar';
import {AlertColor} from '@mui/material';

export interface SnackbarItem extends SnackbarProps {
  message: string;
  severity: AlertColor;
  withConfetti?: boolean;
}

interface SnackbarContext {
  snackbarItem: null | SnackbarItem;
  setSnackbarItem: (item: SnackbarItem | null) => void;
}

const snackbarContext = React.createContext<SnackbarContext>({
  snackbarItem: null,
  setSnackbarItem: () => undefined,
});

type SnackbarProviderProps = {
  children: React.ReactNode;
};

export const SnackbarProvider = ({children}: SnackbarProviderProps) => {
  const [snackbarItem, setSnackbarItem] = React.useState<null | SnackbarItem>(
    null,
  );

  return (
    <snackbarContext.Provider
      value={{
        snackbarItem,
        setSnackbarItem,
      }}
    >
      {children}
    </snackbarContext.Provider>
  );
};

export default snackbarContext;
